import React from "react";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import iChooseIcon from "./typeofgift-ichoose.webp";
import theyChooseIcon from "./typeofgift-theychoose.webp";

type GiftChooserSelectionStepProps = {
	readonly onGiftChooserSelect: (chooser: "myself" | "recipient") => void;
};

export default function GiftChooserSelectionStep({
	onGiftChooserSelect,
}: GiftChooserSelectionStepProps) {
	const t = useTranslator();
	return (
		<div className="get-started-step">
			<div className="get-started-content">
				<h1 className="get-started-title">{t("Who will choose the image?")}</h1>

				<div className="gift-options">
					<button
						className="gift-option"
						onClick={() => onGiftChooserSelect("myself")}
						type="button"
					>
						<div className="gift-option-content">
							<div className="gift-icon-section">
								<div className="gift-icon">
									<img src={iChooseIcon} alt={t("I'll choose")} />
								</div>
							</div>
							<div className="gift-header-section">
								<h2>{t("I'll choose")}</h2>
							</div>
							<div className="gift-text-section">
								<p>{t("Select or upload a photo now")}</p>
							</div>
						</div>
					</button>

					<button
						className="gift-option"
						onClick={() => onGiftChooserSelect("recipient")}
						type="button"
					>
						<div className="gift-option-content">
							<div className="gift-icon-section">
								<div className="gift-icon">
									<img src={theyChooseIcon} alt={t("Let them choose")} />
								</div>
							</div>
							<div className="gift-header-section">
								<h2>{t("Let them choose")}</h2>
							</div>
							<div className="gift-text-section">
								<p>{t("Your recipient will pick/design it later")}</p>
							</div>
						</div>
					</button>
				</div>
			</div>
		</div>
	);
}
